export const getCountry = ({ country }) => country.data;
